import { Card, CardContent, Grid, Paper, TextField } from "@mui/material";
import { useLocalizationContext } from "@mui/x-date-pickers/internals/hooks/useUtils";
import React, { useContext, useState } from "react";
import { Form, Link, Navigate, redirect, useActionData, useLoaderData, useLocation, useNavigate, useNavigation } from "react-router-dom";
import { Descendant } from "slate";
import { Button, Dropdown, DropdownItem, Heading, Label, LoadingSpinner, RadioButton, RadioButtonGroup, Text, TextInput } from "suomifi-ui-components";
import { RAKAlueidenkayttopaatos, RAKLupapaatos, RAKPaatos, RytjAPI } from "../api/rytj/rytj-api";
import { rytjCodes } from "../api/rytj/rytj-codelist";
import { UserContext } from "../App";
import AreaDecisionEdit from "../components/area-decision/AreaDecisionEdit";
import CustomDropdown from "../components/common/CustomDropdown";
import SlateTextEditor, { slateDeserialize, slateSerialize } from "../components/common/SlateTextEditor";
import DateInput from "../components/DateInput";
import PermissionDecisionEdit from "../components/permission-decision/PermissionDecisionEdit";




type TextInputValue = string | number | undefined;

interface Props {

}

interface ActionData {
  error?: string
}
const DecisionEdit: React.FC<Props> = (props) => {
  // TODO:
  //const { id } = useParams();
  const location = useLocation();
  //const navigate = useNavigate();
  const user = useContext(UserContext);
  const loaderData = useLoaderData() as { paatos?: RAKPaatos, alueidenkayttopaatos?: RAKAlueidenkayttopaatos, lupapaatos?: RAKLupapaatos };

  //const localization = useLocalizationContext();
  //const localeCode = localization.utils.locale?.code;

  const areaDecision = loaderData?.alueidenkayttopaatos;
  const permissionDecision = loaderData?.lupapaatos;
  const decision = loaderData?.paatos;
  const navigation = useNavigation();
  const loading = navigation.state === "loading";
  const submitting = navigation.state === "submitting";

  const [type, setType] = useState(permissionDecision ? "permissionDecision" : "areaDecision")
  const data = useActionData() as ActionData;

  const isNew = decision?.versiointitiedot?.identiteettitunnus === undefined;

  

  //const isLoggedIn = sessionStorage.getItem("user") !== null;

  
  const isLoggedIn = user?.isLoggedIn;

  if (!isNew && location.pathname==="/decision/new") {
    //window.location.href="/decision/edit/" + decision?.versiointitiedot?.identiteettitunnus;
    //navigate("/decision/edit/" + decision?.versiointitiedot?.identiteettitunnus, { replace: true });
    // loading = true;
    return <>
    {/* TODO Note this will redirect to decision view, is there a better way to do this? */}
    <Navigate to={"/decision/edit/" + decision?.versiointitiedot?.identiteettitunnus} replace /> 
    <LoadingSpinner
      status="loading"
      text="Lataa..."
      textAlign="right"
      variant="normal"
    />
  </>
  }

  return loading ?
    <Card>
      <CardContent>
        <LoadingSpinner
          status="loading"
          text="Noutaa päätöksiä..."
          textAlign="right"
          variant="normal"
        />
      </CardContent>
    </Card>
    :
    <Form method="post" action={location.pathname}>
      <Grid container rowSpacing={2}>
        <Grid item>
          <Link to={"/decision/view/" + encodeURI(decision?.versiointitiedot?.identiteettitunnus || "")}>
            <Button icon="close" variant='secondary'>Peruuta</Button>
          </Link>
        </Grid>
        <Grid item style={{ flexGrow: "1" }} />
        <Grid item>
          <Button type="submit" icon="save" variant='default' disabled={submitting || !isLoggedIn}>Tallenna</Button>
        </Grid>

        <Grid item xs={12}>

          {decision ?
            <Paper className="mainPaper" sx={{ minHeight: '80vh', marginBottom: "40px" }}>

              <Grid container columnSpacing={10} rowSpacing={5}>
                {data && data.error && 
                <Grid item sm={12}>
                  <Text color="alertBase">{data.error}</Text>
                </Grid>
                }
                <Grid item sm={12}>
                  {decision.versiointitiedot ?
                    <Heading variant='h2'>Muokkaa päätöstä: {decision.paatoksennimi}</Heading> :
                    <Heading variant='h2'>Luo uusi päätös</Heading>
                  }
                  {!isNew ?
                    <input type="hidden" name="ylaluokka.versiointitiedot.identiteettitunnus" defaultValue={decision.versiointitiedot?.identiteettitunnus}></input>
                    :
                    <>
                      <TextInput required className="input--custom" name="ylaluokka.versiointitiedot.identiteettitunnus" labelText="Versiointitietojen identiteettitunnus" defaultValue={""}></TextInput>

                      <RadioButtonGroup className="input--custom" onChange={(value) => { setType(value); }}
                        defaultValue={type}
                        labelText="Päätöksen tyyppi"
                        name="typeOfDecision"
                      >
                        <RadioButton value="areaDecision">
                          Alueidenkäyttöpäätös
                        </RadioButton>
                        <RadioButton value="permissionDecision">
                          Lupapäätös
                        </RadioButton>
                      </RadioButtonGroup>
                    </>
                  }
                </Grid>
                <Grid item sm={12} md={6}>

                  <Heading variant="h3">Päätöksen perustiedot</Heading>
                  <TextInput required className="input--custom" name="ylaluokka.paatoksennimi" labelText='Päätöksen nimi' defaultValue={decision.paatoksennimi}></TextInput>

                  <SlateTextEditor labelText="Päätösteksti" name="ylaluokka.paatosteksti" value={decision.paatosteksti}></SlateTextEditor>

                  <TextInput className="input--custom" name="ylaluokka.paatospykala" labelText='Päätöspykälä' defaultValue={decision.paatospykala}></TextInput>

                  <TextInput required className="input--custom" name="ylaluokka.paatoksentekija2" labelText="Päätöksen tekijä" disabled={false} defaultValue={decision.paatoksentekija2}></TextInput>

                  <CustomDropdown labelText="Päättäjän laji"
                    name="ylaluokka.paattajanLaji"
                    defaultValue={decision.paattajanLaji}
                    codegroup={rytjCodes.rytj_PaatoksenTekija}></CustomDropdown>

                  {/* <Dropdown className="input--custom"
                    labelText="Päättäjän laji"
                    name="ylaluokka.paattajanLaji"
                    defaultValue={"01" || decision.paattajanLaji}
                  >
                    <DropdownItem value=" ">- Valitse -</DropdownItem>
                    <DropdownItem value="01">
                      Viranhaltija
                    </DropdownItem>
                    <DropdownItem value="02">
                      Monijäseninen päätöksentekoelin
                    </DropdownItem>
                  </Dropdown> */}

                  <DateInput required name="ylaluokka.paatoksenantopaivamaara" labelText="Päätöksen päivämäärä" disabled={true} defaultValue={decision.paatoksenantopaivamaara || new Date().toLocaleDateString()} />

                  <DateInput required name="ylaluokka.julkaisemisenpaivamaara" labelText="Päätöksen julkaisemispäivämäärä" defaultValue={decision.julkaisemisenpaivamaara || new Date().toLocaleDateString()}></DateInput>

                  <DateInput required name="ylaluokka.paatoksenlainvoimaisuuspaivamaara" labelText="Päätöksen lainvoimaisuuspäivämäärä" defaultValue={decision.paatoksenlainvoimaisuuspaivamaara || new Date().toLocaleDateString()} />

                  <DateInput name="ylaluokka.paatoksenraukeaminen" labelText="Päätöksen raukeaminen" defaultValue={decision.paatoksenraukeaminen } />{/* mallissa se ei ole päivämäärä, vaan optionaalinen teksti */}


                  {/* <CustomDropdown labelText="Päätöksen tila"
                    name="ylaluokka.paatoksentila"
                    defaultValue={decision.paatoksentila}
                    codegroup="?"></CustomDropdown> */}

                  <Dropdown className="input--custom"
                    labelText="Päätöksen tila"
                    name="ylaluokka.paatoksentila"
                    defaultValue={decision.paatoksentila}
                  >
                    <DropdownItem value=" ">- Valitse -</DropdownItem>
                    <DropdownItem value="Lainvoimainen">
                      Lainvoimainen
                    </DropdownItem>
                    <DropdownItem value="Osittain voimassa">
                      Osittain voimassa
                    </DropdownItem>
                    <DropdownItem value="Voimassa">
                      Voimassa
                    </DropdownItem>
                    <DropdownItem value="Kumottu">
                      Kumottu
                    </DropdownItem>
                    <DropdownItem value="Valituksen alainen">
                      Valituksen alainen
                    </DropdownItem>
                  </Dropdown>


                  <CustomDropdown
                    labelText="Päätöksen tulos"
                    name="ylaluokka.paatoksentulos"
                    defaultValue={decision.paatoksentulos} codegroup={rytjCodes.rytj_PaatoksenTulos}></CustomDropdown>
                  {/* <Dropdown className="input--custom"
                    labelText="Päätöksen tulos"
                    name="ylaluokka.paatoksentulos"
                    defaultValue={decision.paatoksentulos}>
                    <DropdownItem value=" ">- Valitse -</DropdownItem>
                    <DropdownItem value="01">
                      Myönnetty
                    </DropdownItem>
                    <DropdownItem value="02">
                      Evätty
                    </DropdownItem>
                  </Dropdown> */}


                </Grid>

                {type === "areaDecision" &&
                  <Grid item sm={12} md={6}>
                    <Heading variant="h3">Alueidenkäyttöpäätöksen</Heading>
                    <AreaDecisionEdit areaDecision={areaDecision || {}}></AreaDecisionEdit>
                  </Grid>
                }


                {type === "permissionDecision" &&
                  <Grid item sm={12} md={6}>
                    <Heading variant="h3">Lupapäätöksen tiedot</Heading>
                    <PermissionDecisionEdit permissionDecision={permissionDecision || {}}></PermissionDecisionEdit>
                  </Grid>
                }


              </Grid>

            </Paper>
            :
            <p>not found</p>
          }

        </Grid>

      </Grid>
    </Form>

};

export default DecisionEdit;

// assumes that form names are correct...
const storeKeyValueDataToObject = (rootObject: Record<string, any>, key: string, value: unknown): void => {

  // const arrIndex = key.indexOf("[");

  // if (arrIndex === 0) {
  //   const endIndex = key.indexOf("]");
  //   const firstkey = key.substring(1, endIndex) 
  //   const restkey = key.substring(dotIndex+1);
  //   storeKeyValueDataToObject(rootObject[firstkey])
  // }
  const arrIndex = key.indexOf("[");
  const dotIndex = key.indexOf(".");


  if (dotIndex >= 0 && (arrIndex === -1 || dotIndex < arrIndex)) {
    // dot
    const firstkey = key.substring(0, dotIndex);
    const restkey = key.substring(dotIndex + 1);
    if (rootObject[firstkey] === undefined) {
      rootObject[firstkey] = {};
    }
    storeKeyValueDataToObject(rootObject[firstkey], restkey, value);
  }
  else if (arrIndex >= 0) {
    // array
    const endIndex = key.indexOf("]");
    if (endIndex === -1 || endIndex < arrIndex) {
      console.log("incorrect key name, cannot parse form data from the input name, missing ']' character");
      return;
    }
    const firstkey = arrIndex === 0 ? key.substring(1, endIndex) : key.substring(0, arrIndex);
    const restkey = key.substring(endIndex + 1);
    if (arrIndex === 0) {
      if (restkey.length === 0) {
        rootObject[firstkey] = value;
        return;
      }
      else {
        if (rootObject[firstkey] === undefined) {
          rootObject[firstkey] = {};
        }
        storeKeyValueDataToObject(rootObject[firstkey], restkey, value);
        return;
      }
    }
    const arrayIndex = key.substring(arrIndex + 1, endIndex); //parseInt(key.substring(arrIndex+1, endIndex), 10);

    if (rootObject[firstkey] === undefined) {
      rootObject[firstkey] = [];
    }
    if (restkey.length === 0) {
      rootObject[firstkey][arrayIndex] = value
    }
    else {
      if (rootObject[firstkey][arrayIndex] === undefined) {
        rootObject[firstkey][arrayIndex] = {};
      }
      storeKeyValueDataToObject(rootObject[firstkey][arrayIndex], restkey, value);
    }
  }
  else {
    rootObject[key] = value;
  }
}

const convertSlateJsonToHtml = (slateJson: string): string => {
  let arrayOfNodes = JSON.parse(slateJson) as [];

  const htmlBuilder: string[] = [];
  for (const node of arrayOfNodes) {
    htmlBuilder.push(slateSerialize(node));
  }
  return htmlBuilder.join("");//"\n");
}

export const decisionPostAction = async ({ request }: any) => {
  const data = await request.formData();


  // const ylaluokka: Partial<RAKPaatos> = {
  //   versiointitiedot: {}
  //   //paatoksennimi: data.get("paatoksennimi")
  // };

  // switch (data.get("typeOfDecision")) {
  //   case "areaDecision":
  //     break;
  //   case "permissionDecision":
  //     break;
  //   default:
  //     break;
  // }

  let json: Record<string, any> = {};

  for (const pair of data.entries()) {
    storeKeyValueDataToObject(json, pair[0], pair[1]);
  }

  
  let typeOfDecision = json.typeOfDecision;
  if (typeOfDecision === undefined) {
    if (json?.lupatunnus?.tunnus) { 
      typeOfDecision = "permissionDecision";
    }
    else if (json?.alueidenkayttopaatoksentunnus?.tunnus) {
      typeOfDecision = "areaDecision";
    }
  }
  delete json.typeOfDecision;

  //const rakennustyotvalmistuttavaviimeistaan = json["rakennustyotvalmistuttavaviimeistaan"];
  //json = {"ylaluokka":{"versiointitiedot":{"identiteettitunnus":"0123456-7"},"paatoksennimi":"Uusi päätös","paatosteksti":"[{\"type\":\"paragraph\",\"children\":[{\"text\":\"Rakennuslupa myönnetään hakijalle Maija Meikäläiselle uuden omakotitalon rakentamiseen kiinteistötunnus 0123456-7 tontille. Lupaa myönnetään edellyttäen, että rakennus suunnitellaan ja rakennetaan voimassa olevien rakentamismääräysten ja lainsäädännön vaatimusten mukaisesti. Kattomateriaalina tulee käyttää tiiliä. \"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"Perustelut:\"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"Lupaviranomainen on tutkinut hakemuksen ja huomioinut, että hakija on esittänyt tarvittavat asiakirjat ja suunnitelmat, jotka täyttävät kaikki rakentamismääräykset ja lainsäädännön vaatimukset. Rakennuslupa myönnetään edellyttäen, että rakentaminen toteutetaan ehdotusten mukaisesti.\"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"\"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"Valitusoikeus:\"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"Tästä päätöksestä voi valittaa hallinto-oikeuteen. Valitusaika on 30 päivää tämän päätöksen tiedoksisaannista.\"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"\"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"Tämä päätös annetaan julkipanon jälkeen, kun mahdollinen valitus on käsitelty.\"}]}]","paatospykala":"4321","paatoksentekija2":"Pekka Päättäjä","paattajanLaji":"01","paatoksenantopaivamaara":"2023-02-28T20:49:38.121Z","julkaisemisenpaivamaara":"2023-02-28T20:49:38.121Z","paatoksenlainvoimaisuuspaivamaara":"2023-02-28T20:49:38.121Z","paatoksenraukeaminen":"","paatoksentila":"Voimassa","paatoksentulos":"01"},"lupatunnus":{"tunnus":"0123456-7","tunnuksenantaja":"Pekka Päättäjä"},"sijoittamis-toteuttamislupa":"sijoittamis ja toteuttamislupa","rakennustyotaloitettavaviimeistaan":"2023-02-28T22:00:00.000Z","rakennustyotvalmistuttavaviimeistaan":"2023-02-28T22:00:00.000Z","lupamaarays":[{"lupamaaraysteksti":"Rakennustyöt on aloitettava kahden vuoden kuluessa tämän päätöksen antopäivästä.","lupamaarayksenlaji":"M0201"},{"lupamaaraysteksti":"Rakennustyön aikana on huolehdittava siitä, että työ ei aiheuta vaaraa tai haittaa ympäristölle tai naapurikiinteistöille.","lupamaarayksenlaji":"M0302"},{"lupamaaraysteksti":"Rakennustyössä on noudatettava kaikkia turvallisuusmääräyksiä, jotka ovat voimassa rakennusalan työpaikoilla.","lupamaarayksenlaji":"M0104"}]};

  // paatosteksti is serialized, get real json object

  // Fix slate fields
  json["ylaluokka"]["paatosteksti"] = convertSlateJsonToHtml(json["ylaluokka"]["paatosteksti"]);
  if (json["lupamaarays"]) {
    for (const lupamaarays of json["lupamaarays"]) {
      lupamaarays.lupamaaraysteksti = convertSlateJsonToHtml(lupamaarays.lupamaaraysteksti);
    }
  }
  

  const rytjApi = new RytjAPI({ baseUrl: "/rytj-api" });
  console.log(JSON.stringify(json));
  let result: RAKAlueidenkayttopaatos|RAKLupapaatos;
  try {
    switch (typeOfDecision) {
      case "areaDecision":
        result = (await rytjApi.paatos.alueidenkayttopaatosPost(json?.ylaluokka?.versiointitiedot?.identiteettitunnus, json as RAKAlueidenkayttopaatos)).data;
        break;
      case "permissionDecision":
        result = (await rytjApi.paatos.lupapaatosPost(json?.ylaluokka?.versiointitiedot?.identiteettitunnus, json)).data;
        break;      
      default:
        const message = "Not implemented, unsupported typeof decision!";
        console.log(JSON.stringify(json));
        return { error: message};
    }
    
    if (result.ylaluokka?.versiointitiedot?.identiteettitunnus) {
      //debugger;
      const path = "/decision/view/" + encodeURI(result.ylaluokka?.versiointitiedot?.identiteettitunnus);
      //redirect(path); // TODO figure out why this does not work
      window.location.href = path; // TODO fix this
      return {} as ActionData;
    }
  }
  catch (e: any) {
    return {
      error: e?.error?.Message || e?.error?.message || "Tuntematon virhe tapahtui, tarkista kentät ja yritä uudestaan."
    }
  }

  return { error: "Not implemented!" } as ActionData;

  //return redirect('/paatos');
}